import { Injectable, OnInit, enableProdMode } from '@angular/core';

@Injectable()
export class Config{
    private productionMode=true;
    getProdMode(){
        return this.productionMode;
    }
}